/* Ink, the shop's chat assistant. Talks to the studio's chat endpoint; keeps the thread for this tab only. */
(function () {
  'use strict';
  const root = document.getElementById('chat'); if (!root) return;
  const endpoint = root.dataset.endpoint, name = root.dataset.name || 'Ink';
  const fab = document.getElementById('chatFab'), panel = document.getElementById('chatPanel'), log = document.getElementById('chatLog');
  const form = document.getElementById('chatForm'), input = document.getElementById('chatInput'), chips = document.getElementById('chatChips');
  const KEY = 'a1chat';
  let thread = [];
  try { thread = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { thread = []; }
  let busy = false;

  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // bold, bare product paths and full links become clickable; everything else stays text
  const fmt = s => esc(s)
    .replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
    .replace(/(^|[\s(])(\/(?:products|collections|pages|policies|search)[\w\-\/#?=&.]*|\/#\w+)/g, (m, pre, path) => `${pre}<a href="${path.replace(/[.,)]+$/, '')}">${path.replace(/[.,)]+$/, '')}</a>`)
    .replace(/(https?:\/\/[^\s<]+[^\s<.,)])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
    .replace(/\n{2,}/g, '</p><p>').replace(/\n/g, '<br>');

  const bubble = (role, text, extra) => {
    const el = document.createElement('div'); el.className = 'chat-msg ' + role + (extra ? ' ' + extra : '');
    el.innerHTML = role === 'bot' ? `<p>${fmt(text)}</p>` : `<p>${esc(text)}</p>`;
    log.appendChild(el); log.scrollTop = log.scrollHeight; return el;
  };
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(thread.slice(-20))); } catch (e) {} };
  const render = () => {
    log.innerHTML = '';
    bubble('bot', root.dataset.greeting || `Hi, I'm ${name}. How can we help?`);
    thread.forEach(m => bubble(m.role === 'user' ? 'me' : 'bot', m.content));
    chips.hidden = thread.length > 0;
  };

  const open = () => { panel.hidden = false; fab.setAttribute('aria-expanded', 'true'); root.classList.add('open'); if (!log.children.length) render(); setTimeout(() => input.focus(), 50); };
  const close = () => { panel.hidden = true; fab.setAttribute('aria-expanded', 'false'); root.classList.remove('open'); };
  fab.addEventListener('click', () => panel.hidden ? open() : close());
  document.getElementById('chatClose').addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) close(); });

  async function ask(q) {
    q = (q || '').trim(); if (!q || busy) return;
    busy = true; chips.hidden = true;
    thread.push({ role: 'user', content: q }); bubble('me', q); save();
    input.value = ''; input.disabled = true;
    const wait = bubble('bot', '', 'typing'); wait.innerHTML = '<span></span><span></span><span></span>';
    try {
      const r = await fetch(endpoint, {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ messages: thread.slice(-12), ctx: { email: root.dataset.email, page: location.pathname } })
      });
      const data = await r.json().catch(() => ({}));
      wait.remove();
      if (r.ok && data.reply) { thread.push({ role: 'assistant', content: data.reply }); bubble('bot', data.reply); save(); }
      else bubble('bot', data.error || `Something went wrong on our end. Call us at ${root.dataset.phone} and we will sort it out.`);
    } catch (e) {
      wait.remove(); bubble('bot', `We could not reach the assistant just now. Call us at ${root.dataset.phone}.`);
    }
    busy = false; input.disabled = false; input.focus();
  }
  form.addEventListener('submit', e => { e.preventDefault(); ask(input.value); });
  chips.addEventListener('click', e => { const b = e.target.closest('button'); if (b) ask(b.textContent); });

  // nudge once per tab after the visitor has been around a while
  if (!sessionStorage.getItem(KEY + ':seen')) {
    setTimeout(() => { root.classList.add('nudge'); try { sessionStorage.setItem(KEY + ':seen', '1'); } catch (e) {} }, 12000);
  }
})();
